import React from "react";
import LegalDocument from "../../components/LegalDocument";
import { PRIVACY_POLICY } from "../../lib/legalContent";

export default function Privacy() {
  return <LegalDocument doc={PRIVACY_POLICY} testid="privacy-page" otherLink={{ to: "/terms", label: "Terms of Service" }} />;
}
